import zhLocale from '@jdt/find/lib/locale/lang/zh-CN'
export default {
  ...zhLocale,
}
